import React, { Dispatch, useState } from 'react';
import { useQuery } from 'react-query';
import * as Yup from 'yup'
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import ApiCalls from '../../network/ApiCalls';
import { UserAction } from '../../redux/actionTypes/userActionTypes';
import TurnifyLoading from '../../umut-components/Loading/TurnifyLoading';
import * as ActionCreators from '../../redux/actionCreators/userActionCreators';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form'
import { AcceptStaffInviteRequest } from '../../network/PostRequestModels';
import { AdminAcceptRequest } from '../../interfaces/Admins';

const schema = Yup.object().shape({
    newPassword: Yup.string()
        .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/, 'Password must contain minimum eight characters, at least one uppercase letter, one lowercase letter and one number')
        .required('Password is required'),
    newPasswordAgain: Yup.string().oneOf([Yup.ref('newPassword'), null], 'Password must be matched'),
})

type ParamObj = {
    token: string
}

type PasswordInput = {
    newPassword: string;
    newPasswordAgain: string;
}

const defaultValues: PasswordInput = {
    newPassword: '',
    newPasswordAgain: '',
}

const AdminConfirm: React.FC = () => {
    const dispatch = useDispatch<Dispatch<UserAction>>();
    const query = new URLSearchParams(useLocation().search);
    const token = query.get("token");
    const history = useHistory();
    const [acceptSuccess, setAcceptSuccess] = useState<boolean | null>(null);
    const [loading, setLoading] = useState(false);

    const { control, formState, handleSubmit, reset, register } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    const { isValid, dirtyFields, errors } = formState;

    const sendPassword = async (data: PasswordInput) => {
        try {
            setLoading(true);

            let request: AdminAcceptRequest = {
                token: token ?? '',
                newPassword: data.newPassword
            }
            await ApiCalls.acceptAdmin(request);
            setAcceptSuccess(true);
        }
        catch (err: any) {
            setAcceptSuccess(false);
        }
    }

    if (acceptSuccess === null) {
        return (
            <div className='rounded p-6 d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>
                <form
                    className='form w-100 w-md-600px p-10 border rounded shadow'
                    onSubmit={handleSubmit(sendPassword)}
                    noValidate
                    id='kt_login_signin_form'
                >
                    <div className="mb-10 d-flex justfiy-content-center">
                        <img style={{ width: "100%" }} src="media/logos/turnify-logo.png" alt="turnify-logo" />
                    </div>
                    {/* begin::Heading */}
                    <div className='mb-10 text-center'>
                        {/* begin::Title */}
                        <h1 className='text-dark mb-3'>Confirm Account</h1>
                        {/* end::Title */}
                    </div>
                    {/* end::Heading */}

                    {/* begin::Form group */}
                    <div className='fv-row mb-10'>
                        <div className='d-flex justify-content-between mt-n5'>
                            <div className='d-flex flex-stack mb-2'>
                                {/* begin::Label */}
                                <label className='form-label fw-bolder text-dark fs-6 mb-0'>Password</label>
                                {/* end::Label */}
                            </div>
                        </div>
                        <input
                            {...register("newPassword")}
                            type='password'
                            autoComplete='off'
                            className='form-control form-control-lg form-control-solid'
                            required
                        />
                        <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.newPassword?.message}</p>
                    </div>
                    {/* end::Form group */}

                    {/* begin::Form group */}
                    <div className='fv-row mb-10'>
                        <div className='d-flex justify-content-between mt-n5'>
                            <div className='d-flex flex-stack mb-2'>
                                {/* begin::Label */}
                                <label className='form-label fw-bolder text-dark fs-6 mb-0'>New Password Again</label>
                                {/* end::Label */}
                            </div>
                        </div>
                        <input
                            {...register("newPasswordAgain")}
                            type='password'
                            autoComplete='off'
                            className='form-control form-control-lg form-control-solid'
                            required
                        />
                        <p style={{ color: 'red', fontWeight: 'bold' }}>{errors.newPasswordAgain?.message}</p>
                    </div>
                    {/* end::Form group */}

                    {/* begin::Action */}
                    <div className='text-center'>
                        <button
                            type='submit'
                            id='kt_sign_in_submit'
                            className='btn btn-lg btn-primary w-100 mb-5'
                            disabled={!isValid || loading}
                        >
                            {!loading && <span className='indicator-label'>Continue</span>}
                            {loading && (
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    Please wait...
                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                            )}
                        </button>
                    </div>
                    {/* end::Action */}
                </form>
            </div>
        )
    }

    if (acceptSuccess) {
        return (
            <div className="d-flex justify-content-center align-items-center flex-column" style={{ height: '100vh', fontSize: 40, fontWeight: 'bold' }}>
                <img alt="error" style={{ width: 150, height: 150, marginTop: "15px" }} src={toAbsoluteUrl('/media/icons/success.png')} />
                Confirm Success
                <button className="btn btn-success mt-6" onClick={() => {
                    dispatch(ActionCreators.logout());
                    history.replace('/auth/login');
                }}>Back to Login Page</button>


                {/* <button className="btn btn-success" onClick={() => {
                    dispatch(ActionCreators.logout());
                    history.replace('/auth/login');
                }}>Back to Login Page</button> */}
            </div>
        )
    }

    if (!acceptSuccess) {
        return (
            <div className="d-flex justify-content-center align-items-center flex-column" style={{ height: '100vh', fontSize: 40, fontWeight: 'bold' }}>
                <img alt="error" style={{ width: 150, height: 150 }} src={toAbsoluteUrl('/media/icons/danger.png')} />
                Error
                <button className="btn btn-danger" onClick={() => {
                    dispatch(ActionCreators.logout());
                    history.replace('/auth/login');
                }}>Back to Login Page</button>
            </div>
        )
    }


    return null;
}

export default AdminConfirm;